/**
 * PTVision — «Рукописный и сложный шрифт» for /photo-translate.
 *
 * The browser's recogniser is trained on print; on handwriting and decorative
 * lettering it returns nonsense, while its DETECTOR still finds every line — ink is
 * ink. So this lane keeps what the browser does well (where the lines are) and asks
 * a vision model only for what it does badly (what they say):
 *
 *   1. prepare(): a copy of the photo, scaled to the lane's long edge, with every
 *      block the page found drawn as a numbered frame. Tags sit OUTSIDE the text —
 *      left of the frame when there is room, above it otherwise — so a tag never
 *      covers the letters it labels.
 *   2. send(): that copy and the frame numbers go to POST /photo-translate/vision
 *      (PhotoTranslateVisionHandler). Machine-readable request (X-Requested-With,
 *      redirect: 'error'), so a refusal comes back as JSON and never as a page.
 *   3. apply(): each frame the model read replaces the browser's reading of THAT
 *      block; its position, erase box and colours stay as measured.
 *
 * This is the only path in the tool that sends the photo itself, and it runs only on
 * its own button — see config/photo-vision.php.
 *
 * Exposed as window.PTVision.
 */
(function (root) {
    'use strict';
    if (root.PTVision) return;

    var COLORS = ['#e5195e', '#0a6cff', '#12a150', '#e07b00', '#8e3ad6'];

    /** Blocks → {blob, ids}: an annotated JPEG and the frame numbers, in block order. */
    function prepare(base, blocks, maxEdge) {
        var long = Math.max(base.width, base.height) || 1;
        var scale = Math.min(1, (maxEdge || 2576) / long);
        var w = Math.max(1, Math.round(base.width * scale));
        var h = Math.max(1, Math.round(base.height * scale));
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var ctx = c.getContext('2d');
        ctx.drawImage(base, 0, 0, w, h);

        var ids = [];
        var lw = Math.max(2, Math.round(Math.min(w, h) / 360));
        var fs = Math.max(13, Math.round(Math.min(w, h) / 42));
        ctx.font = '700 ' + fs + 'px system-ui, -apple-system, "Segoe UI", sans-serif';
        ctx.textBaseline = 'middle';

        blocks.forEach(function (b, i) {
            if (!b || b.hidden || !b.box) return;         // a skipped block stays skipped
            var id = i + 1;
            ids.push(id);
            var box = (b.paint && b.paint.box) || b.box;
            var x = box.x * scale, y = box.y * scale, bw = box.w * scale, bh = box.h * scale;
            var col = COLORS[i % COLORS.length];

            ctx.lineWidth = lw;
            ctx.strokeStyle = col;
            ctx.strokeRect(x - lw, y - lw, bw + 2 * lw, bh + 2 * lw);

            var label = String(id);
            var tw = ctx.measureText(label).width + fs * 0.7;
            var th = fs * 1.35;
            var lx, ly;
            if (x - lw - tw >= 0) { lx = x - lw - tw; ly = y - lw; }          // left of the frame
            else if (y - lw - th >= 0) { lx = x - lw; ly = y - lw - th; }       // above it
            else { lx = x - lw; ly = y + bh + lw; }                             // below it
            ctx.fillStyle = col;
            ctx.fillRect(lx, ly, tw, th);
            ctx.fillStyle = '#ffffff';
            ctx.fillText(label, lx + fs * 0.35, ly + th / 2);
        });

        return new Promise(function (resolve) {
            c.toBlob(function (blob) { resolve({ blob: blob, ids: ids, width: w, height: h }); }, 'image/jpeg', 0.9);
        });
    }

    async function send(cfg, prepared, src, tgt, signal) {
        var fd = new FormData();
        fd.append('image', prepared.blob, 'photo.jpg');
        fd.append('frames', JSON.stringify(prepared.ids));
        fd.append('tgt', tgt || '');
        if (src && src !== 'auto') fd.append('src', src);
        var meta = document.querySelector('meta[name="csrf-token"]');
        var res = await fetch(cfg.url, {
            method: 'POST',
            body: fd,
            credentials: 'same-origin',
            redirect: 'error',
            signal: signal,
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': meta ? meta.getAttribute('content') || '' : '',
            },
        });
        var data = null;
        try { data = await res.json(); } catch (_) { data = null; }
        if (!res.ok || !data || data.success !== true) {
            var err = new Error((data && data.error) || ('HTTP ' + res.status));
            err.status = res.status;
            err.premium = res.status === 402;
            throw err;
        }
        return data;
    }

    /**
     * Frames the model read → blocks. A frame it returned empty keeps the browser's
     * reading: an honest "could not read" must not wipe a line that was read.
     * @return number of blocks replaced
     */
    function apply(blocks, regions) {
        var byId = {};
        (regions || []).forEach(function (r) { if (r && r.id != null) byId[r.id] = r; });
        var n = 0;
        (blocks || []).forEach(function (b, i) {
            var r = byId[i + 1];
            if (!b || b.hidden || !r || !String(r.text || '').trim()) return;
            b.text = r.text;
            b.translated = String(r.translation || '').trim() ? r.translation : r.text;
            b.translateFailed = false;
            b.edited = null;
            b.vision = true;
            n++;
        });
        return n;
    }

    root.PTVision = { prepare: prepare, send: send, apply: apply };
})(window);
